import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-92effec4")
const _hoisted_1 = { class: "contents issue-area" }
const _hoisted_2 = { class: "inner flex-box jc-sb" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ISSUE")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("課題")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("周りの進捗が早すぎて焦る")
const _hoisted_6 = { class: "img-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 周りの進捗が見えるため、自分が遅れていると段々焦ってハンズオンの理解に集中できない。 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("初歩的な質問をするのが恥ずかしい")
const _hoisted_9 = { class: "img-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 質問をしたものの、初歩的なミスで恥ずかしくなった。 ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_head_english = _resolveComponent("top-head-english")!
  const _component_heading = _resolveComponent("heading")!
  const _component_retina_img = _resolveComponent("retina-img")!
  const _component_top_card = _resolveComponent("top-card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_top_head_english, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_heading, {
        level: 2,
        textAlign: "left",
        isFullWidth: true
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_top_card, {
        widthType: "half",
        number: "01"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_heading, {
            level: 3,
            fontSize: "xl"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_retina_img, {
              src: "/images/ss-slack01.png",
              alt: "Slackで進捗管理をしている図",
              width: 436,
              height: 189,
              loading: "lazy"
            })
          ]),
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_top_card, {
        widthType: "half",
        number: "02"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_heading, {
            level: 3,
            fontSize: "xl"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_retina_img, {
              src: "/images/ss-slack02.png",
              alt: "Slackで質問をしている図",
              width: 440,
              height: 183,
              loading: "lazy"
            })
          ]),
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}